/**
 * Sleep for a specified number of milliseconds.
 *
 * @param {number} ms - The number of milliseconds to sleep.
 * @returns {Promise} A promise that resolves after the specified time has elapsed.
 */
export default function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
